var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "object",
    title: "Object",
    description: "A generic object. Can optionally include a 'fields' specification for nested validation.",
    type: "field",
    alais: ["fields", "field"],
    use: {
        namespace: "ua.fields.schema.editor"
    },
    fields: {
        // Optional fields for nested validation
        fields: {
            title: "Fields",
            type: "object",
            description: "An object defining the schema for nested properties. Each property can have its own validation rules.",
            optional: true
        }
    },
    tests: {
        validObject: {
            must: true,
            run: function () {
                return validate({ type: "object" }, { key: "value" });
            }
        },
        invalid: {
            throw: "fields.object.invalid",
            run: function () {
                return validate({ type: "object" }, "not-an-object");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Object",
            description: "The value must be a plain object.",
            template: "Expected object but received ${type}"
        }
    }
});

var fieldsManager = false;// require("../uam/fields.js");

function validate(spec, value) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
        _.errors.invalid.throw({ type: typeof value });
    }

    // //first check if the spec has a fields definition
    // if (spec.fields && typeof spec.fields === "object") {

    //     //now check the fields manager is defined
    //     if (!fieldsManager) {
    //         fieldsManager = require("../uam/fields.js");
    //     }

    //     Hoping the system takes over.
    //    // Validate the nested fields if they exist
    //     fieldsManager.Validate(spec.fields, value);
        
    // }

}
module.exports.validate = validate;
